import { createAction, props } from "@ngrx/store";
import { Language } from "cli-types";

export const loadActiveLanguages = createAction(
    "[Courses] Load Active Languages",
    props<{
        payload: string;
    }>()
);
export const loadActiveLanguagesFail = createAction(
    "[Courses] Load Active Languages Fail",
    props<{
        payload: any;
    }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadActiveLanguagesSuccess = createAction(
    "[Courses] Load Active Languages Success",
    props<{
        payload: Language[];
    }>()
);
